<div class="body-products">
    <div *ngFor="let product of this.productList" class="product-item">
        <div class="product-label">
            <span>{{product.productName}}-Amount</span>
        </div>
        <div class="product-amount">
            <span><app-indian-currency-formatter
                [amount]="product.investmentAmount">
            </app-indian-currency-formatter></span>
        </div>
    </div>
</div>